import React from "react";

interface FooterSocialProps {
  className?: string;
}

const FooterSocial: React.FC<FooterSocialProps> = ({ className }) => {
  const socialLinks = [
    { icon: "fa-facebook-f", label: "Facebook", href: "#" },
    { icon: "fa-instagram", label: "Instagram", href: "#" },
    { icon: "fa-youtube", label: "YouTube", href: "#" },
    { icon: "fa-tiktok", label: "TikTok", href: "#" },
  ];

  return (
    <div className={className}>
      <h3 className="mb-4 font-semibold text-white">Suivez-nous</h3>
      <div className="mb-4 flex gap-4">
        {socialLinks.map((social, index) => (
          <a
            key={index}
            href={social.href}
            aria-label={`Suivez-nous sur ${social.label}`}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-700 text-white hover:bg-meteoyellow-500 hover:text-nearblack-500"
          >
            <i className={`fab ${social.icon}`}></i>
          </a>
        ))}
      </div>
      <p className="text-sm text-gray-400">
        La source d'information météo la moins digne de confiance des Québécois
        et des Canadiens*
      </p>
      <p className="mt-2 text-xs text-gray-500">
        *D'après une étude imaginaire de MétéoMédiocre 2026
      </p>
    </div>
  );
};

export default FooterSocial;
